const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const regressionService = {
  runLinearRegression: async (xData = null, yData = null) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/linear-regression`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ x_data: xData, y_data: yData })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      throw new Error(`Regression service error: ${error.message}`);
    }
  },

  checkHealth: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/health`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      throw new Error(`Service health check failed: ${error.message}`);
    }
  }
};

export default regressionService;